import $ from 'jquery';
import { dataLayerEventExist } from '../site/helpers';

class ExpertiseFilter {
  constructor(selector) {
    this.container = $(selector);
    this.items = this.container.find('.filter-item');

    this._setListeners();
    // 1. Run the check immediately on load
    this._updateFilterFromHash();
  }

  _setListeners() {
    this.items.on('click', (event) => this._handleItemClick(event));

    // 2. FIXED: Listen for changes to the URL hash while already on the page
    $(window).on('hashchange', () => this._updateFilterFromHash());
  }

  // Renamed from _checkHashOnLoad to _updateFilterFromHash to reflect that it runs on load AND on change
  _updateFilterFromHash() {
    // Get the hash (e.g., "#web-design")
    const hash = window.location.hash;

    // Only proceed if a hash exists
    if (hash) {
      // Remove the '#' symbol to get just the slug
      const slug = hash.substring(1);

      // Find the item that matches this ID or data-slug
      const targetItem = this.items.filter(`#${slug}`);

      // If we found a matching item in this list
      if (targetItem.length > 0) {
        // Remove active from all items first
        this.items.removeClass('active');

        // Add active to the linked item
        targetItem.addClass('active');

        // Optional: Scroll handling
        // $('html, body').animate({
        //     scrollTop: targetItem.offset().top - 100
        // }, 500);
      }
    }
  }

  _handleItemClick(event) {
    const target = $(event.currentTarget);

    // Safety check to ensure we are clicking a filter item
    if (!target.hasClass('filter-item')) return;

    const buttonText = target.find('h3').text();

    // Remove 'active' class from all items
    this.items.removeClass('active');

    // Add 'active' class to the clicked item
    target.addClass('active');

    const slug = target.attr('id');

    // Update URL.
    // NOTE: using replaceState does NOT trigger 'hashchange',
    // which prevents an infinite loop with the listener we just added.
    if (slug) {
      history.replaceState(null, null, `#${slug}`);
    }

    // GTM
    if (!dataLayerEventExist('expertiseCategoryClick', buttonText)) {
      window.dataLayer.push({
        event: 'expertiseCategoryClick',
        eventLabel: buttonText
      });
    }
  }
}

const expertiseFilter = (selector) => {
  $(selector).each((index, element) => {
    new ExpertiseFilter(element);
  });
};

export default expertiseFilter;
